import { CONTENT_HOME_SET, SELECTED_REGION_SET } from './types';

export default {
  [CONTENT_HOME_SET](state, payload) {
    const currentState = state;
    currentState.content = payload;
  },
  [SELECTED_REGION_SET](state, payload) {
    const currentState = state;
    currentState.selectedRegionTid = payload;
  },
};
